export const SESSION_COOKIE = 'cnct_editor_session';
export const SESSION_TTL_MS = 12 * 60 * 60 * 1000; // 12 часов

export interface EditorSession {
  lastProjectId: string;
  lastActiveAt: number; // epoch ms
}

export function serializeSession(s: EditorSession): string {
  return `${s.lastProjectId}.${s.lastActiveAt}`;
}

export function parseSession(raw: string | null | undefined): EditorSession | null {
  if (!raw) return null;
  const idx = raw.lastIndexOf('.');
  if (idx <= 0) return null; // нет разделителя или пустой id
  const lastProjectId = raw.slice(0, idx);
  const lastActiveAt = Number(raw.slice(idx + 1));
  if (!lastProjectId || !Number.isFinite(lastActiveAt)) return null;
  return { lastProjectId, lastActiveAt };
}

export function isSessionFresh(s: EditorSession | null, now: number): boolean {
  if (!s) return false;
  const age = now - s.lastActiveAt;
  return age >= 0 && age <= SESSION_TTL_MS;
}

export type EntryDecision =
  | { screen: 'empty' }
  | { screen: 'hub' }
  | { screen: 'resume'; projectId: string };

export function decideEntryState(args: {
  projectIds: string[];
  session: EditorSession | null;
  now: number;
}): EntryDecision {
  const { projectIds, session, now } = args;
  if (projectIds.length === 0) return { screen: 'empty' };
  if (session && isSessionFresh(session, now) && projectIds.includes(session.lastProjectId)) {
    return { screen: 'resume', projectId: session.lastProjectId };
  }
  return { screen: 'hub' };
}
